import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Star, MapPin, CheckCircle } from 'lucide-react';

const BookingHeader = ({ serviceId, service, vendor, serviceRating, serviceReviews }) => {
  return (
    <div className="mb-8 sm:mb-16">
      <Link
        to={`/services/${serviceId}`}
        className="inline-flex items-center text-black hover:text-gray-600 mb-6 sm:mb-10 transition-colors group"
      >
        <ArrowLeft className="w-4 h-4 mr-2 group-hover:-translate-x-1 transition-transform" />
        <span className="text-sm font-medium">Back</span>
      </Link>

      <div className="space-y-4 sm:space-y-6">
        {/* Service Title */}
        <div>
          <h1 className="text-xl sm:text-2xl lg:text-3xl xl:text-4xl font-bold text-black mb-3 sm:mb-4 leading-tight">
            Book {service?.service_name}
          </h1>

          <div className="flex flex-wrap items-center gap-3 sm:gap-6">
            <div className="flex items-center text-gray-600">
              <span className="text-sm sm:text-base">by</span>
              <span className="ml-2 text-sm sm:text-base font-semibold text-black">
                {vendor?.business_name}
              </span>
            </div>

            <div className="flex items-center gap-2">
              <div className="flex">
                {[1, 2, 3, 4, 5].map((star) => (
                  <Star
                    key={star}
                    className={`w-3 h-3 sm:w-4 sm:h-4 ${
                      star <= Math.floor(serviceRating)
                        ? 'text-black fill-current'
                        : 'text-gray-300'
                    }`}
                  />
                ))}
              </div>
              <span className="text-xs sm:text-sm font-semibold text-black">
                {typeof serviceRating === 'number' && !isNaN(serviceRating)
                  ? serviceRating.toFixed(1)
                  : '0.0'}
              </span>
              <span className="text-gray-500 text-xs sm:text-sm">
                ({serviceReviews} reviews)
              </span>
            </div>
          </div>
        </div>

        {/* Location and Verification */}
        <div className="flex flex-wrap items-center gap-3 sm:gap-4 pt-3 sm:pt-4 border-t border-gray-200">
          {vendor?.is_verified && (
            <div className="inline-flex items-center gap-1 sm:gap-1.5 rounded-full bg-gradient-to-r from-emerald-50 to-teal-50 border border-emerald-200/80 px-2.5 sm:px-3 py-1 sm:py-1.5 shadow-[0_1px_2px_rgba(16,185,129,0.15)]">
              <CheckCircle className="w-3 h-3 sm:w-3.5 sm:h-3.5 text-emerald-600" strokeWidth={2.5} />
              <span className="text-xs font-semibold text-emerald-700 tracking-wide">Verified Vendor</span>
            </div>
          )}
          <div className="flex items-center text-gray-600">
            <MapPin className="w-3.5 h-3.5 sm:w-4 sm:h-4 mr-1.5 sm:mr-2 text-black" />
            <span className="text-xs sm:text-sm font-medium">
              {vendor
                ? `${vendor.city}, ${vendor.state}`
                : 'Location not available'}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingHeader;

